import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCampaignsCampaignAlertPreferencesDeleteCampaignIdCacheKeys: AllRouteEndpoints[] = [];
